export const FRAME_TRANSITION_STALL_SLOT_OVERRUN_MARGIN_MS = 500

export interface IFrameTransitionStallDetectInput {
  nowMs: number
  documentVisible: boolean
  queueLength: number
  frameDurationMs: number
  visibleFrameStartMs: number
  suppressBecauseRegistrationResync: boolean
  suppressBecauseRegistrationTransitionHold: boolean
}

export interface IFrameTransitionStallStatus {
  suspected: boolean
  overrunMs: number
}

export function detectFrameTransitionStall(input: IFrameTransitionStallDetectInput): IFrameTransitionStallStatus {
  const {
    nowMs,
    documentVisible,
    queueLength,
    frameDurationMs,
    visibleFrameStartMs,
    suppressBecauseRegistrationResync,
    suppressBecauseRegistrationTransitionHold
  } = input

  if (
    !documentVisible
    || queueLength < 1
    || frameDurationMs <= 0
    || visibleFrameStartMs <= 0
    || suppressBecauseRegistrationResync
    || suppressBecauseRegistrationTransitionHold
  ) {
    return { suspected: false, overrunMs: 0 }
  }

  const visibleDwellMs = Math.max(0, nowMs - visibleFrameStartMs)
  const overrunMs = visibleDwellMs - frameDurationMs
  const suspected = overrunMs > FRAME_TRANSITION_STALL_SLOT_OVERRUN_MARGIN_MS
  return {
    suspected,
    overrunMs: suspected ? Math.max(0, overrunMs) : 0
  }
}
